import { Customer } from "./customer";
import { UnitType } from "./unit-type";
import { User } from "./user";

export class Unity {
    unit_type_id:number = 0;
    unit_type:UnitType = new UnitType();
    brand:string = '';
    model:string =  '';
    serial_num:string =  '';
    engine_serial_num:string =  '';
    chassis_serial_num:string =  '';
    color:string =  '';
    licence_plate:string =  '';
    customer_id:number = 0;
    customer:Customer = new Customer();
    num_rims:number = 0;
    measure_rims:number = 0;
    capacity:number = 0;
    litres:number = 0;
    performance:number = 0;
    insurance_policy:string =  '';
    insurance_issue_date:Date = new Date();
    insurance_expiration_date:Date = new Date();
    folder:string =  '';
    gas_type:string =  'Diesel';
    id:number = 0;
    active:boolean = true;
    image:boolean = false;
    circulation_num:string =  '';
    sct_permission:string =  '';
    physical_mechanics_date:Date = new Date();
    physical_mechanics_date_2:Date = new Date();
    pollutant_date:Date = new Date();
    pollutant_date_2:Date = new Date();
    user:User = new User();
    user_id:number = 0;
    user_second:User = new User();
    user_second_id:number = null;
    ubication:string =  'Planta 1';
    physical_mechanics_number:string = '';//
    contaminants_verification_number:string = '';//
    insurance_subsection_number:string = '';//
    insurance_coverage_type:string = '';//
    insurance_cost:number = 0;//
    physical_mechanics_cost:number = 0;
    contaminants_verification_cost:number = 0;
    permission_type:string = 'Carga General';
    customer_type:string = null;

    gps_number_1:string = '';
    gps_brand_1:string = '';
    gps_number_2:string = '';
    gps_brand_2:string = '';
    sap_project:string = '';

    history_kms:number = 0;
}
